<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading
      heading="Библиотека компетенций"
    >
      <span slot="help"></span>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openEditDialog"
          >
            Добавить компетенцию
          </el-button>
        </div>
      </div>
    </page-heading>

    <el-card>
      <competencies-component
        ref="competenciesComponent"
        :on-edit-competence="openEditDialog"
      ></competencies-component>
    </el-card>

    <competence-edit-dialog
      ref="editDialog"
      @competence-saved="loadCompetencies"
    >
    </competence-edit-dialog>
  </div>
</template>

<script>
import CompetenceEditDialog from "@/modules/evaluation/components/competence/CompetenceEditDialog.vue";
import CompetenciesComponent from "@/modules/evaluation/components/competence/CompetenciesComponent";
import PageHeading from "@/components/PageHeading";

export default {
  name: 'eval-competencies',
  components: {
    CompetenciesComponent,
    CompetenceEditDialog,
    PageHeading,
  },
  methods: {
    openEditDialog(competence = {}) {
      this.$refs.editDialog.open(competence);
    },
    loadCompetencies(){
      if (this.$refs.competenciesComponent) {
        this.$refs.competenciesComponent.loadCompetencies();
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>